import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=61cc8d28&scoped=true"
import script from "./personCenter.vue?vue&type=script&lang=js"
export * from "./personCenter.vue?vue&type=script&lang=js"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=61cc8d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc8d28",
  null
  
)

export default component.exports